var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.confirmation)?_c('div',{staticClass:"password-match-hint",class:_vm.matchClass},[_c('b-icon',{attrs:{"icon":_vm.matches ? 'check-circle-fill' : 'x-circle-fill'}}),_c('span',{staticClass:"ml-1"},[_vm._v(_vm._s(_vm.matches ? 'Passwords match' : "Passwords don't match"))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }